<template>
  <div id="cartitem">
    <section>
      <!-- <div class="caution_field" v-if="cartData.isDisProduct===true">
        <div class="caution_inner">
          <ul class="caution_text">
            <li>この商品は商品仕様が変更、または取り扱いが終了した為、購入できません。</li>
            <li>カートから削除してください。</li>
          </ul>
        </div>
      </div> -->
      <div class="product_field">
        <div class="image" v-bind:class="{'disabled':cartData.isDisProduct===true}">
          <img :src="itemImage" class="product_image">
        </div>
        <div class="product_info">
          <div class="product_title">{{cartData.planEc.ecParamProductName}}</div><!-- 商品名 -->
          <ul class="product_info_list">
            <li>
              <div>メーカー名</div>
              <div>{{cartData.makerData.corpName}}</div>
            </li>
            <li v-if="cartData.planEc.ecParamSeriesName">
              <div>シリーズ名</div>
              <div>{{cartData.planEc.ecParamSeriesName}}</div>
            </li>
            <li>
              <div>商品名</div>
              <div>{{cartData.planEc.ecParamProductName}}</div>
            </li>
            <li>
              <div>商品サイズ</div>
              <div>
                <div class="confirm_size">
                  <span>W:{{cartData.planEc.ecParamW}}mm</span>
                  <span v-if="cartData.planEc.ecParamW2">W2:{{cartData.planEc.ecParamW2}}mm</span>
                </div>
                <div class="confirm_size">
                  <span>H:{{cartData.planEc.ecParamH}}mm</span>
                  <span v-if="cartData.planEc.ecParamH2">H2:{{cartData.planEc.ecParamH2}}mm</span>
                </div>
                <div class="confirm_size">
                  <span>D:{{cartData.planEc.ecParamD}}mm</span>
                  <span v-if="cartData.planEc.ecParamD2">D2:{{cartData.planEc.ecParamD2}}mm</span>
                </div>
                <div>
                  <span v-show="cartData.planEc.ecParamFillerLeft!=undefined">{{labelLeftFiller}}:{{cartData.planEc.ecParamFillerLeft}}mm</span>
                </div>
                <div>
                  <span v-show="cartData.planEc.ecParamFillerRight!=undefined">{{labelRightFiller}}:{{cartData.planEc.ecParamFillerRight}}mm</span>
                </div>
                <div>
                  <span v-show="cartData.planEc.ecParamFillerCenter!=undefined">{{labelCenterFiller}}:{{cartData.planEc.ecParamFillerCenter}}mm</span>
                </div>
              </div>
            </li>
            <li v-bind:class="{'some':true, 'disabled':cartData.isDisProduct===true}" v-if="isExistStyle">
              <span>スタイル名</span>
              <span>{{cartData.colorStyle.colorStyleName}}</span>
            </li>
            <li v-if="isDoor" v-bind:class="{'disabled':cartData.isDisProduct===true}">
              <div>扉カラー</div>
              <div>{{colorDoor.name}}</div>
            </li>
            <li v-if="isCabine" v-bind:class="{'disabled':cartData.isDisProduct===true}">
              <div>キャビネット/棚/脚カラー</div>
              <div>{{colorCabine.name}}</div>
            </li>
            <li v-if="isCounter" v-bind:class="{'disabled':cartData.isDisProduct===true}">
              <div>カウンターカラー</div>
              <div>{{colorCounter.name}}</div>
            </li>
            <li v-if="cartData.planEc.ecParamShelfCount">
              <div>{{optShelfTitle}}</div>
              <div>{{cartData.planEc.ecParamShelfCount}}{{optShelfUnitTitle}}本</div>
            </li>
            <li v-if="cartData.planEc.ecParamFillerCount">
              <div>追加フィラー</div>
              <div>{{cartData.planEc.ecParamFillerCount}}本</div>
            </li>
            <li>
              <div>組立設置</div>
              <div>{{dispConstruct}}</div>
            </li>
            <li>
              <div>納品先</div>
              <div v-if="cartData.planData.planDeliveryPostcd">〒{{cartData.planData.planDeliveryPostcd}}</div>
              <div v-else></div>
            </li>
            <li>
              <div>組立設置先</div>
              <div v-if="cartData.planData.planStructPostcd">〒{{cartData.planData.planStructPostcd}}</div>
              <div v-else></div>
            </li>
            <li v-if="isOutputCG && isCarryIn != undefined">
              <div>受け取り搬入サービス</div>
              <div>{{isCarryIn}}</div>
            </li>
          </ul>
          <div class="product_act_filed">
            <div>
              <dd-counter
                ref="ddCounterRef"
                :initCount="cartData.planEc.ecParamProductCount"
                :type="type"
              />
              <div class="procut_price">{{formatPrice(priceData.totalTax)}}</div>
            </div>
            <div>
              <div v-bind:class="{reload_btn: true, disabled: !isExecUpdate}" @click="onUpdate(cartData)" v-on:mouseover="isOnReload(true)" v-on:mouseleave="isOnReload(false)" v-if="type!='history'">
                <img :src="imgReload" class="icon">
                <a>再計算</a>
              </div>
              <div class="product_action_list">
                <ul>
                  <li v-if="type==='cart'" @click="onAfterCart(cartData)">後で買う</li>
                  <li v-else-if="type!='history'" @click="onReverseCart(cartData)">カートに戻す</li>
                  <li @click="onEstimate()">料金・商品図面を見る</li>
                  <li v-if="type!='history'">
                    <div @click="onDelete(cartData)">
                      <img :src="imgTrash" class="icon">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import {DC_STORAGE_KEY} from '../../../constants/App'
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
import DcCounter from './DcCounter'

export default {
  name: 'CartItem',
  components: {
    'dd-counter': DcCounter
  },
  props: {
    cartData: Object,
    type: String,
    isOutputCG: Boolean,
    isBeforeDate: {
      type: Boolean,
      default: false
    },
    odMgId: String,
    resrchFlag: {
      type: Boolean,
      default: false
    },
    resrchPriceData: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      titleNoData: {},
      imgReload: this.getImage('common/reload_black.svg'),
      imgTrash: this.getImage('common/icon_trash.svg')
    }
  },
  computed: {
    productCount: function () {
      if (!this.$refs.ddCounterRef) return this.cartData.planEc.ecParamProductCount
      return this.$refs.ddCounterRef.getCount()
    },
    priceData: function () {
      let priceData = {
        itemName: this.cartData.planEc.ecParamProductName,
        itemModelList: this.cartData.planEc.ecSnapPriceDetail,
        itemPrice: this.cartData.planEc.ecSnapItemPrice,
        itemDeliPrice: this.cartData.planEc.ecSnapItemPrice,
        constructTotalPrice: this.cartData.planEc.ecSnapOptionSubTotalPrice,
        constructTotalTax: this.cartData.planEc.ecSnapOptionSubTotalTax,
        constructPrice: this.cartData.planEc.ecSnapConstructPrice,
        subTotalPrice: this.cartData.planEc.ecSnapSubTotalPrice,
        subTotalTax: this.cartData.planEc.ecSnapSubTotalTax,
        delivaryPrice: this.cartData.planEc.ecSnapDeliveryPrice,
        // totalPrice: this.cartData.planEc.ecSnapPrice,
        // totalTax: this.cartData.planEc.ecSnapTaxIncludedTotalPrice,
        totalTax: this.cartData.planEc.ecSnapTaxIncludedTotalPrice,
        executionVarExpensesPrice: this.cartData.planEc.ecSnapExecutionVarExpensesPrice,
        carryInPrice: this.cartData.planEc.ecSnapCarryInPrice,
        // constructTotalPrice: this.cartData.planEc.ecSnapOptionSubTotalPrice,
        // constructTotalTax: this.cartData.planEc.ecSnapOptionSubTotalTax,
        productCount: this.productCount,
        profitProb: this.profitProb
        // develop marge
        // optionSubTotalPrice: this.cartData.planEc.ecSnapOptionSubTotalPrice,
        // optionSubTotalTax: this.cartData.planEc.ecSnapOptionSubTotalTax,
      }
      return priceData
    },
    itemImage: function () {
      if (!this.cartData || !this.cartData.planEc.ecSnapProductImage) return this.getImage('noimage.svg')
      return this.getImage(this.bigImage(this.cartData.planEc.ecSnapProductImage))
    },
    colorDoor: function () {
      if (!this.cartData || !this.cartData.doorColor || Object.keys(this.cartData.doorColor).length <= 0) return undefined
      let data = this.cartData.doorColor
      let color = {
        id: data.no,
        name: data.name,
        type: data.type,
        no: data.dispNo,
        img: this.getImage('color/' + data.img),
        imgB: this.getImage('color/' + this.bigImage(data.img))
      }
      return color
    },
    colorCabine: function () {
      if (!this.cartData || !this.cartData.boxColor || Object.keys(this.cartData.boxColor).length <= 0) return undefined
      let data = this.cartData.boxColor
      let color = {
        id: data.no,
        name: data.name,
        type: data.type,
        no: data.dispNo,
        img: this.getImage('color/' + data.img),
        imgB: this.getImage('color/' + this.bigImage(data.img))
      }
      return color
    },
    colorCounter: function () {
      if (!this.cartData || !this.cartData.centerColor || Object.keys(this.cartData.centerColor).length <= 0) return undefined
      let data = this.cartData.centerColor
      let color = {
        id: data.no,
        name: data.name,
        type: data.type,
        no: data.dispNo,
        img: this.getImage('color/' + data.img),
        imgB: this.getImage('color/' + this.bigImage(data.img))
      }
      return color
    },
    isDoor: function () {
      if (!this.cartData.doorColor || Object.keys(this.cartData.doorColor).length <= 0) return false
      return true
    },
    isCabine: function () {
      if (!this.cartData.boxColor || Object.keys(this.cartData.boxColor).length <= 0) return false
      return true
    },
    isCounter: function () {
      if (!this.cartData.centerColor || Object.keys(this.cartData.centerColor).length <= 0) return false
      return true
    },
    dispConstruct: function () {
      return FormUtil.getOnOff(this.cartData.planEc.ecInfoOpExFlag)
    },
    isConstruct: function () {
      return this.cartData.planEc.ecInfoOpExFlag === true
    },
    optShelfTitle: function () {
      if (this.cartData.planEc.ecSnapCategoryType === 5) return 'ご注文数'
      return '追加可動棚'
    },
    optShelfUnitTitle: function () {
      if (this.cartData.planEc.ecSnapCategoryType === 5) return '枚'
      return '枚/列'
    },
    labelFiller: function () {
      if (this.cartData.planEc.ecSnapCategoryType === 4) return '壁埋め込み'
      return 'フィラー'
    },
    labelLeftFiller: function () {
      if (this.cartData.planEc.ecSnapCategoryType === 4) return '左壁埋め込み'
      return '左フィラー'
    },
    labelRightFiller: function () {
      if (this.cartData.planEc.ecSnapCategoryType === 4) return '右壁埋め込み'
      return '右フィラー'
    },
    labelCenterFiller: function () {
      if (this.cartData.planEc.ecSnapCategoryType === 4) return '奥壁埋め込み'
      return '上部フィラー'
    },
    doorColor: function () {
      if (!this.cartData.doorColor) return
      let bigName = FormUtil.bigImage(this.cartData.doorColor.img)
      let color = {
        id: this.cartData.doorColor.no,
        name: this.cartData.doorColor.name,
        type: this.cartData.doorColor.type,
        no: this.cartData.doorColor.dispNo,
        img: this.getImage('color/' + this.cartData.doorColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    boxColor: function () {
      if (!this.cartData.boxColor) return
      let bigName = FormUtil.bigImage(this.cartData.boxColor.img)
      let color = {
        id: this.cartData.boxColor.no,
        name: this.cartData.boxColor.name,
        type: this.cartData.boxColor.type,
        no: this.cartData.boxColor.dispNo,
        img: this.getImage('color/' + this.cartData.boxColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    centerColor: function () {
      if (!this.cartData.centerColor) return
      let bigName = FormUtil.bigImage(this.cartData.centerColor.img)
      let color = {
        id: this.cartData.centerColor.no,
        name: this.cartData.centerColor.name,
        type: this.cartData.centerColor.type,
        no: this.cartData.centerColor.dispNo,
        img: this.getImage('color/' + this.cartData.centerColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    isMiuraCompany: function () {
      if (this.cartData.makerData.corpId === 1001) {
        return true
      }
      return false
    },
    isExistStyle: function () {
      if (this.cartData.colorStyle && Object.keys(this.cartData.colorStyle).length > 0 && this.cartData.colorStyle.colorStyleName) {
        return true
      }
      return false
    },
    isExecUpdate: function () {
      if (this.productCount > 0) {
        return true
      }
      return false
    },
    productSize: function () {
      let sizeList = []
      if (this.cartData.planEc.ecParamW) sizeList.push('W:' + this.cartData.planEc.ecParamW)
      if (this.cartData.planEc.ecParamW2) sizeList.push('W2:' + this.cartData.planEc.ecParamW2)
      if (this.cartData.planEc.ecParamH) sizeList.push('H:' + this.cartData.planEc.ecParamH)
      if (this.cartData.planEc.ecParamH2) sizeList.push('H2:' + this.cartData.planEc.ecParamH2)
      if (this.cartData.planEc.ecParamD) sizeList.push('D:' + this.cartData.planEc.ecParamD)
      if (this.cartData.planEc.ecParamD2) sizeList.push('D2:' + this.cartData.planEc.ecParamD2)
      if (this.cartData.planEc.ecParamFillerLeft) sizeList.push('左フィラー:' + this.cartData.planEc.ecParamFillerLeft)
      if (this.cartData.planEc.ecParamFillerRight) sizeList.push('右フィラー' + this.cartData.planEc.ecParamFillerRight)
      if (this.cartData.planEc.ecParamFillerCenter) sizeList.push('上部フィラー' + this.cartData.planEc.ecParamFillerCenter)
      return sizeList.join('、')
    },
    productColor: function () {
      let colorList = []
      if (this.isDoor) colorList.push(this.colorDoor.name)
      if (this.isCabine) colorList.push(this.colorCabine.name)
      if (this.isCounter) colorList.push(this.colorCounter.name)
      return colorList.join('、')
    }
  }, // end computed
  methods: {
    onAfterCart: function (cartData) {
      this.$emit('afterCart', cartData.planData.planOrderCode)
    },
    onReverseCart: function (cartData) {
      this.$emit('reverseCart', cartData.planData.planOrderCode)
    },
    onEstimate: function () {
      let estimateData = {
        fileName: this.cartData.planEc.ecParamProductName,
        titleDoor: '扉カラー',
        colorDoor: this.doorColor,
        titleCabine: 'キャビネット/棚/脚カラー',
        colorCabine: this.boxColor,
        titleCounter: 'カウンターカラー',
        colorCounter: this.centerColor,
        priceData: this.priceData,
        targetPlan: this.targetPlan,
        spaceJoincd: this.cartData.fileData.spaceJoincd,
        dcProductCount: this.productCount,
        isDrawing: this.cartData.planEc.ecSnapCategoryType !== 5,
        makerData: this.cartData.makerData,
        isProductData: this.isBeforeData,
        isNetPrice: this.isHaseko
      }
      this.$emit('onShowEstimateModal', estimateData)
    },
    onCG: function (cartData) {
      this.$emit('showCameraModal', cartData)
    },
    onDelete: function (cartData) {
      this.$emit('deleteCartItem', cartData.planData.planOrderCode)
    },
    onUpdate: function (cartData) {
      this.$emit('updateProductCnt', cartData.planData.planOrderCode, this.productCount)
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    setTitleNo: function () {
      let count = 1
      this.$set(this.titleNoData, 'filler', count++)
      this.$set(this.titleNoData, 'size', count++)
      if (this.cartData.doorColor && Object.keys(this.cartData.doorColor).length > 0) {
        this.$set(this.titleNoData, 'doorColor', count++)
      }
      if (this.cartData.boxColor && Object.keys(this.cartData.boxColor).length > 0) {
        this.$set(this.titleNoData, 'boxColor', count++)
      }
      if (this.cartData.centerColor && Object.keys(this.cartData.centerColor).length > 0) {
        this.$set(this.titleNoData, 'centerColor', count++)
      }
      this.$set(this.titleNoData, 'construct', count++)
      this.$set(this.titleNoData, 'price', count++)
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    isOnReload: function (on) {
      if (on) {
        this.imgReload = this.getImage('common/reload_white.svg')
      } else {
        this.imgReload = this.getImage('common/reload_black.svg')
      }
    }
  }, // end method
  mounted: function () {
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.setTitleNo()
  }
}
</script>
<style src="../../css/dc-cart.scss" lang="scss" scoped></style>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/DcCartItem.vue